module.exports = __webpack_public_path__ + "img/profile.ea0f52e1.svg";